import { render, staticRenderFns } from "./CustomerTreatmentColumnNew.vue?vue&type=template&id=4f318928&scoped=true&"
import script from "./CustomerTreatmentColumnNew.vue?vue&type=script&lang=js&"
export * from "./CustomerTreatmentColumnNew.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTreatmentColumnNew.vue?vue&type=style&index=0&id=4f318928&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f318928",
  null
  
)

export default component.exports